import { Helmet } from 'react-helmet-async'

export const NotificationsPage = () => (
    <>
        <Helmet>
            <title>Notifications</title>
        </Helmet>
        <div className="p-4">
            <h1>Notifications</h1>
        </div>
    </>
)
